import twelveLogoWithText from "@assets/images/twelve-logo-with-text.svg?url";

// "Powered by Twelve" footer for public-facing branded forms (referral intake, online scheduling).
// `label` is overridable so i18n'd surfaces can pass a translated string.
export function PoweredByTwelve(props: { label?: string }) {
  return (
    <div class="my-4 flex items-center justify-center gap-2 text-sm text-typography-secondary">
      <span>{props.label ?? "Powered by"}</span>
      <a href="https://twelve.ai" target="_blank" rel="noopener noreferrer">
        <img src={twelveLogoWithText} class="h-4 w-auto" alt="Twelve" />
      </a>
    </div>
  );
}
